import axios from "axios";

export default class Api {

    constructor(keycloak) {
        this.keycloak = keycloak;
    }

    getRaw(callback, noAuth) {
        let baseUrl = process.env.VUE_APP_API_HOST;
        let axiosFunction = (value) => {
            let axiosObject = axios.create({baseURL: baseUrl, timeout: 180000});
            axiosObject.CancelToken = axios.CancelToken;
            axiosObject.isCancel = axios.isCancel;
            axiosObject.defaults.headers.common.Authorization = "Bearer " + value;
            callback(axiosObject);
        };
        if (noAuth === true) {
            callback(axios.create({baseURL: baseUrl, timeout: 10000}));
        } else {
            axiosFunction(this.keycloak.token)
        }
    }
}
